/**
 * @function filterUsers
 * @param { string } input
 * @param { Array } values
 * @returns { Array } filteredValues
 */
const filterUsers = (input, values) => {
	const filteredValues = values.filter((value) => {
		return (
			value.firstName.toLowerCase().includes(input?.toLowerCase()) ||
			value.lastName.toLowerCase().includes(input?.toLowerCase())
		);
	});
	return filteredValues;
};

export default filterUsers;
